import type { ReactNode } from "react";
import s from "./AnswerChip.module.css";

export interface AnswerChipProps {
  children: ReactNode;
  tag?: string;
  dropped?: boolean;
  droppedNote?: string;
}

export function AnswerChip({ children, tag, dropped = false, droppedNote }: AnswerChipProps) {
  return (
    <span className={dropped ? `${s.root} ${s.dropped}` : s.root}>
      {children}
      {dropped && droppedNote && <span className={s.hidden}>{droppedNote}</span>}
      {tag && <span className={s.tag}>{tag}</span>}
    </span>
  );
}

export function AnswerChips({ children }: { children: ReactNode }) {
  return <div className={s.list}>{children}</div>;
}
